module.exports = __webpack_public_path__ + "static/media/canned-sardines-tuna.14d8fd44.png";